import { AppSkeleton } from './AppSkeleton'

/**
 * ChartSkeleton — Reusable Skeleton for Bar and Area Charts
 *
 * @param {object} props
 * @param {number} [props.bars=7]
 * @param {string|number} [props.height='200px']
 */
export function ChartSkeleton({ bars = 7, height = '200px' }) {
  const heights = [45, 75, 60, 90, 65, 80, 50, 85, 70, 95, 60, 75]

  return (
    <div className="flex w-full flex-col gap-4" style={{ height }}>
      {/* Legend / Header */}
      <div className="flex items-center justify-end gap-3">
        <AppSkeleton width="60px" height="12px" />
        <AppSkeleton width="60px" height="12px" />
      </div>

      {/* Bars Area */}
      <div className="flex flex-1 items-end justify-between gap-2 px-2 pb-2">
        {Array.from({ length: bars }).map((_, i) => (
          <div key={i} className="flex flex-1 flex-col items-center gap-2">
            <AppSkeleton
              variant="rectangular"
              width="100%"
              style={{ height: `${heights[i % heights.length]}%` }}
              className="rounded-t-md"
            />
            <AppSkeleton width="24px" height="10px" />
          </div>
        ))}
      </div>
    </div>
  )
}

export default ChartSkeleton
